const history = require('history');

let browserHistory = history.createBrowserHistory();

export const setHistory = (h) => {
  browserHistory = h;
};

export const getHistory = () => browserHistory;
